import React from "react"
import PropTypes from "prop-types"

const EditorContent = React.forwardRef(
  ({ location, children, ...props }, ref) => {
    return (
      <div {...props} id={`${location}-editor`} ref={ref}>
        {children}
      </div>
    )
  }
)

const EditorSidebar = React.forwardRef(
  ({ location, children, ...props }, ref) => {
    return (
      <div {...props} id={`${location}-sidebar`} ref={ref}>
        {children}
      </div>
    )
  }
)

EditorContent.propTypes = {
  location: PropTypes.string.isRequired,
  children: PropTypes.node
}

EditorSidebar.propTypes = {
  location: PropTypes.string.isRequired,
  children: PropTypes.node
}

export { EditorContent, EditorSidebar }
